<template>
  <div class="slds-hint-parent">
    <span class="slds-form-element__label slds-truncate" v-if="label" :title="label">{{label}}</span>
    <Tooltip :text="tooltip" v-if="tooltip" :direction="tooltipDirection" />

    <span class="slds-form-element__label slds-truncate" v-if="noLabel" :title="label">{{nbsp}}</span>
    <div class="slds-form-element__control">
      <slot v-if="type === 'custom'"></slot>
      <div class="slds-form-element__control" v-else-if="type === 'checkbox'">
        <span class="slds-icon_container slds-icon-utility-check slds-current-color" :title="value">
          <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
            <use xlink:href="../../assets/symbols.svg#check" v-if="value"></use>
            <use xlink:href="../../assets/symbols.svg#steps" v-else></use>
          </svg>
          <span class="slds-assistive-text">{{value}}</span>
        </span>
      </div>
      <div class="slds-form-element__static slds-truncate" v-else-if="['array', 'multipicklist', 'range'].includes(type)" >
        <template v-for="(group, groupIndex) in displayValue">
          <ul :key="groupIndex" :class="itemType === 'date' ? '' : 'slds-list_horizontal slds-has-dividers_right'" v-if="displayValue && displayValue.length">
            <li class="slds-item" v-for="item in group" :key="item">
              <span v-if="item">{{ item }}</span>
            </li>
          </ul>
        </template>
      </div>
      <span v-else-if="value && displayValue !== ''">{{displayValue}}</span>
      <span v-else>{{nbsp}}</span>
      <slot v-if="hasAction" name="action"></slot>
    </div>
  </div>

</template>
<script>
import moment from 'moment'
import Tooltip from './Tooltip'

export default {
  components: {
    Tooltip
  },
  props: {
    hasAction: Boolean,
    itemType: String,
    label: String,
    labelsPrefix: String,
    noLabel: Boolean,
    options: Array,
    tooltip: String,
    tooltipDirection: String,
    type: {
      type: String,
      default: 'text'
    },
    value: [Array, Boolean, Number, String, Date, Object]
  },
  computed: {
    displayValue () {
      let value = this.value
      if (this.type !== 'checkbox' && this.value === true) {
        value = ''
      }

      switch (this.type) {
        case 'date':
          return this.mapDateValue(value)
        case 'array':
          return this.mapValueArray(value)
        case 'multipicklist':
          return this.mapValueMultipicklist(value)
        case 'picklist':
          return this.getLabelFromValue(value)
        case 'range':
          return this.mapRangeArray(value)
        case 'boolean':
          return this.getBooleanLabel(value)
        case 'checkbox':
          return this.getCheckboxValue(value)
        case 'text':
          return value
        default:
          return value
      }
    },
    nbsp () {
      return '\xa0'
    }
  },
  created () {
    this.mapLocalOptions(this.options)
  },
  data () {
    return {
      booleanOptions: [
        {
          label: this.$t('general.yes'),
          value: 'Y'
        },
        {
          label: this.$t('general.no'),
          value: 'N'
        }
      ],
      localOptions: []
    }
  },
  methods: {
    getBooleanLabel (value) {
      if (value) {
        return this.booleanOptions.find(option => option.value === value).label
      } else {
        return ''
      }
    },
    getCheckboxValue (value) {
      return this.value === true
    },
    getLabelFromValue (value) {
      try {
        if (value) {
          const obj = this.localOptions.find(option => option.value === value)
          if (obj) return obj.label
          else return ''
        } else {
          return ''
        }
      } catch (error) {
        console.error('Error in OutputField ' + this.label, error)
      }
    },
    mapDateValue (value) {
      return value ? moment(value).format(this.$t('general.dateFormat')) : ''
    },
    mapValueArray (value) {
      return _.chunk(value, 5)
    },
    mapValueMultipicklist (value) {
      try {
        return _.chunk(this.localOptions
          .filter(option => !!value && value.includes(option.value))
          .map(option => option.label), 5)
      } catch (error) {
        console.error('Error in OutputField ' + this.label, error)
      }
    },
    mapLocalOptions (options) {
      if (options) {
        this.localOptions = options.map(option => {
          if (option.label && option.value) {
            return option
          } else {
            return {
              label: this.labelsPrefix ? this.$t(`${this.labelsPrefix}.${option}`) : option,
              value: option
            }
          }
        })
      }
    },
    mapRangeArray (options) {
      try {
        return _.chunk(options.map(option => {
          if (this.itemType === 'date') {
            return `${this.$options.filters.formatDate(option.from, this.$t('general.dateFormat'))} - ${this.$options.filters.formatDate(option.to, this.$t('general.dateFormat'))}`
          } else {
            return `${option.from} - ${option.to}`
          }
        }), 5)
      } catch (error) {
        console.error('Error in OutputField ' + this.label, error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .slds-form-element__control {
    display: flex;
  }
</style>
